import { createStyles } from '@material-ui/core';

export default createStyles({
    root: {
        boxShadow: 'unset',
    },
    sizeSmall: {
        height: '3.6rem',
        width: '3.6rem',
    },
});
